import { defineMessages } from 'react-intl'

export const jobsTablesMessages = defineMessages({
  status: {
    id: 'jobsTablesMessages.status',
    description: 'Text for Jobs table header of "Status"',
    defaultMessage: 'Status',
  },
  jobName: {
    id: 'jobsTablesMessages.jobName',
    description: 'Text for Jobs table header of "Job Name"',
    defaultMessage: 'Job Name',
  },
  homeName: {
    id: 'jobsTablesMessages.homeName',
    description: 'Text for Jobs table header of "Home Name"',
    defaultMessage: 'Home Name',
  },
  updated: {
    id: 'jobsTablesMessages.updated',
    description: 'Text for Jobs  column header of "Updated"',
    defaultMessage: 'Updated',
  },
  softwareVersion: {
    id: 'jobsTablesMessages.softwareVersion',
    description: 'Text for Jobs  column header of "Software version"',
    defaultMessage: 'SavantOS Version',
  },
  subscriptionPlan: {
    id: 'jobsTablesMessages.subscriptionPlan',
    description: 'Text for Jobs  column header of "Subscriptions"',
    defaultMessage: 'Subscriptions',
  },
  subscriptionEnds: {
    id: 'jobsTablesMessages.subscriptionEnds',
    description: 'Text for Jobs  column header of "Subscription Ends"',
    defaultMessage: 'Renewal Date',
  },
  lastBackup: {
    id: 'jobsTablesMessages.lastBackup',
    description: 'Text for Jobs  column header of "Last Backup"',
    defaultMessage: 'Last Backup',
  },
})
